import './RegUser.scss'
import {Row, Col} from "react-bootstrap/esm";
import {useForm} from "react-hook-form";
import {Fab} from "@mui/material";
import {Add, HowToReg, VerifiedUser} from "@mui/icons-material";
import {red} from "@mui/material/colors";
import axios from "axios/index";
import {toast} from "react-toastify";


export default function () {
    // const {register: registerLogIn, handleSubmit: handleSubmitLogIn, formState: {errors: errorsLogIn}} = useForm()

    const {register, handleSubmit: handleSubmitLogIn, formState: {errors}, watch, handleSubmit} = useForm();
    const fun1 = () => {
        console.log('Clicked...')
    };

    const onSubmitLogIn = data => {
        document.body.classList.add('loading-Authentication');
        console.log(data);
        // axios.post(`${baseApiCore}authentication/TokenUser`, data)
        //     .then(response => {
        //
        //             document.body.classList.remove('loading-Authentication');
        //             Cookies.set('auth', response.data.content);
        //             console.log(response.data.content);
        //             nav("/");
        //         }
        //     )
        //     .catch(error => {
        //         document.body.classList.remove('loading-Authentication');
        //         toast.error(error.response.data.message, {
        //             position: "bottom-right",
        //             autoClose: 5000,
        //             hideProgressBar: false,
        //             closeOnClick: true,
        //             pauseOnHover: true,
        //             draggable: true,
        //             progress: undefined,
        //             theme: "colored",
        //         });
        //     });
    }
    return <div>
        <Row className='g-0'>
            <Col>
                <div className='mt-5'
                ></div>
            </Col>
        </Row>
        <form onSubmit={handleSubmitLogIn(onSubmitLogIn)} className='khorshidPishva-form'
              style={{marginBottom: "40%", marginTop: "10%"}}>
            <Row className='g-0'>
                <Col className='px-1'>
                    <input className='form-control' type="text" placeholder="نام" {...register("fristName", {
                        required: "این فیلد الزامی میبشد",
                        maxLength: 30,
                        pattern: {
                            value: /^[\u0600-\u06FF\s]+$/,
                            message: "لطفا نام فارسی خود را وارد نمایید",
                        },
                    })} />
                </Col>
                <Col className='px-1'>
                    <input className='form-control' type="text" placeholder="نام خانوادگی" {...register("lastName", {
                        required: "این فیلد الزامی میبشد",
                        maxLength: 30,
                        pattern: {
                            value: /^[\u0600-\u06FF\s]+$/,
                            message: "لطفا نام فارسی خود را وارد نمایید",
                        },
                    })} />
                </Col>
            </Row>
            <Row className='mt-5 g-0'>
                <Col className='px-1'>
                    <input className='form-control' type="text" placeholder="شماره ملی" {...register("melliCode", {
                        required: "این فیلد الزامی میبشد",
                        maxLength: 30,
                        pattern: {
                            value: /^[\u0600-\u06FF\s]+$/,
                            message: "لطفا نام فارسی خود را وارد نمایید",
                        },
                    })} />
                </Col>
                <Col className='px-1'>
                    <input className='form-control' type="text" placeholder="شماره شناسنامه" {...register("idCard", {
                        required: "این فیلد الزامی میبشد",
                        maxLength: 30,
                        pattern: {
                            value: /^[\u0600-\u06FF\s]+$/,
                            message: "لطفا نام فارسی خود را وارد نمایید",
                        },
                    })} />
                </Col>
            </Row>
            <Row className='mt-5 g-0'>
                <Col className='px-1'>
                    <input className='form-control' type="text" placeholder="تاریخ تولد" {...register("birthDate", {
                        required: "این فیلد الزامی میبشد",
                        maxLength: 30,
                        pattern: {
                            value: /^[\u0600-\u06FF\s]+$/,
                            message: "لطفا نام فارسی خود را وارد نمایید",
                        },
                    })} />
                </Col>
                <Col className='px-1'>
                    <input className='form-control' type="text" placeholder="تاریخ صدور" {...register("publishDate", {
                        required: "این فیلد الزامی میبشد",
                        maxLength: 30,
                        pattern: {
                            value: /^[\u0600-\u06FF\s]+$/,
                            message: "لطفا نام فارسی خود را وارد نمایید",
                        },
                    })} />
                </Col>
            </Row>
            <Row className='mt-5 g-0 '>
                <Col className='px-1'>
                    <input className='form-control' type="text" placeholder="محل تولد" {...register("locationDate", {
                        required: "این فیلد الزامی میبشد",
                        maxLength: 30,
                        pattern: {
                            value: /^[\u0600-\u06FF\s]+$/,
                            message: "لطفا نام فارسی خود را وارد نمایید",
                        },
                    })} />
                </Col>
                <Col className='px-1'>

                </Col>
            </Row>
            <Row className='mt-5 g-0'>
                <Col>
                    <Fab variant="extended" className='btnReg' size={"small"} onClick={fun1}>
                        <HowToReg></HowToReg>
                    </Fab>
                </Col>
            </Row>
        </form>
    </div>
}